jQuery(function(){
  const baseUrl = $('#base-url').data('base-url');

  // Tooltip handler for Basic Information content
  if ($('.basic-information-content').length > 0) {
    const bic = $('.basic-information-content');
    const cbiTO = $('#cbi-tooltip-overlay');

    $('.cbi-tooltip').on('mouseenter', function(){
      const tt = $(this);
      // const y = tt.offset().top - bic.offset().top;
      
      // console.log('bic', bic.position().top, 'tt', tt.position().top);
      // console.log('bic', bic.offset().top, 'tt', tt.offset().top, 'cbiTO', cbiTO.offset().left);

      cbiTO.css('width', bic.width());
      cbiTO.css('top', tt.offset().top);
      cbiTO.find('.chevron').css('left', 2 + tt.offset().left - cbiTO.find('#cbi-tooltip-content').offset().left + 'px');
      cbiTO.find('.tooltip-text').html(tt.data('tooltip'));
      cbiTO.removeClass('opacity-0');
    });

    $('.cbi-tooltip').on('mouseleave', function(){
      cbiTO.addClass('opacity-0');
    });
  }

  // Tooltip handler for Human Rights Treaties content
  if ($('.human-rights-treaties-content').length > 0) {
    const hrtc = $('.human-rights-treaties-content');
    const hrtTO = $('#hrt-tooltip-overlay');
    let mouseoutIgnore = false;
    let mouseTimeout;

    $('.hrt-tooltip').on('mouseenter', function(){
      const tt = $(this);
      const status = tt.data('status');
      const year = tt.data('year');
      const desc = tt.data('description');
      const link = tt.data('link');

      console.log('mouseenter', status, year, desc, link);
      // const y = tt.offset().top - hrtc.offset().top;
      
      hrtTO.find('.hrt-in').hide();

      if (status == '' || status == null) {
        hrtTO.find('.hrt-status-icon img').hide();
      } else {
        if (status === 'State Party') {
          hrtTO.find('.hrt-status-icon img').attr('src', baseUrl + 'themes/custom/gsod/src/assets/icons/icon-ratify-yes.svg');
          hrtTO.find('.hrt-year').text(year);
          hrtTO.find('.hrt-in').show();
        }
        if (status === 'Signatory') {
          hrtTO.find('.hrt-status-icon img').attr('src', baseUrl + 'themes/custom/gsod/src/assets/icons/icon-ratify-wip.svg');
        }
        if (status === 'No Action') {
          hrtTO.find('.hrt-status-icon img').attr('src', baseUrl + 'themes/custom/gsod/src/assets/icons/icon-ratify-no.svg');
        }
        hrtTO.find('.hrt-status-icon img').attr('alt', status);
        hrtTO.find('.hrt-status-icon img').show();
      }
      
      hrtTO.find('.hrt-status').html(status);
      hrtTO.find('.hrt-desc').html(desc);
      
      if (link == '' || link == null) {
        hrtTO.find('.hrt-link').hide();
      } else {
        hrtTO.find('.hrt-link a').attr('href', link);
        hrtTO.find('.hrt-link').show();
      }

      mouseoutIgnore = false;
      clearTimeout(mouseTimeout);

      hrtTO.css('width', hrtc.width());
      hrtTO.css('top', tt.offset().top);
      hrtTO.removeClass('opacity-0');
      hrtTO.removeClass('pointer-events-none');
    });

    $('.hrt-tooltip').on('mouseleave', function(){
      console.log('A');
      mouseTimeout = setTimeout(() => {
        if (!mouseoutIgnore) {
          mouseoutIgnore = false;
          hrtTO.addClass('opacity-0 pointer-events-none');
          // hrtTO.css('top', '-9999px');
        }
      }, 100);
    });

    hrtTO.on('mouseenter', function() {
      mouseoutIgnore = true;
      hrtTO.removeClass('opacity-0 pointer-events-none');
    })

    hrtTO.on('mouseleave', function() {
      console.log('B');
      mouseoutIgnore = false;
      hrtTO.addClass('opacity-0 pointer-events-none');
      // hrtTO.css('top', '-9999px');
    })
  }

  // Tooltip handler for Democracy Summit Tracking content
  if ($('.democracy-summit-tracking-content').length > 0) {
    // const dst = $('.democracy-summit-tracking-content');
    const dstTO = $('#dst-tooltip-overlay');

    $('.dst-tooltip').on('mouseenter', function(){
      const tt = $(this);

      // dstTO.css('width', dst.width());
      dstTO.css('top', tt.offset().top);
      dstTO.css('left', tt.offset().left - 150);
      dstTO.find('.chevron').css('left', 2 + tt.offset().left - dstTO.find('#dst-tooltip-content').offset().left + 'px');
      dstTO.find('.tooltip-text').html(tt.data('tooltip'));
      dstTO.removeClass('opacity-0');
    });

    $('.dst-tooltip').on('mouseleave', function(){
      dstTO.addClass('opacity-0');
    });
  }
});
